export const Roles = [
  { "value": "_developper", "label": "Developper" }, // For developper
  { "value": "_itnova", "label": "It Nova"}, // For Sylvie Gagnon
  { "value": "test2", "label": "test2"}
];
